"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customersApi = void 0;
exports.customersApi = (http, prefix = '/customers') => ({
    getById(id) {
        return http.get(`${prefix}/${id}`);
    },
    create(customer) {
        return http.post(`${prefix}`, customer);
    },
    update(customer) {
        return http.put(`${prefix}/${customer.id}`, customer);
    },
    patch(id, customer) {
        return http.patch(`${prefix}/${id}`, customer);
    },
    search(term) {
        return http.get(`${prefix}/search?q=${term}`);
    },
    getCustomerFinancial(customerId) {
        return http.get(`${prefix}/${customerId}/financial`);
    },
    upsertFinancial(customerId, financial) {
        return http.put(`${prefix}/${customerId}/financial`, financial);
    },
    validate(customerId, isValid) {
        return http.put(`${prefix}/validate/${customerId}`, {
            validate: isValid,
        });
    },
    getLeadById(id) {
        return http.get(`${prefix}/lead/${id}`);
    },
    createLead(name, email) {
        return http.post(`${prefix}/lead`, { lead_name: name, email });
    },
    addAccount(customerId, account) {
        return http.post(`${prefix}/${customerId}/accounts`, account);
    },
});
//# sourceMappingURL=index.js.map